export default __webpack_public_path__ + "static/demolition-tank_removal-7da3d8ac5cacbab13caa6d7b71169b4f.png";